import { DATETIME_FORMAT, DATE_FORMAT, DEFAULT_EMPTY, DELAY_TRANSITION, IMAGE_URL } from 'constants/common';
import { isNull, isUndefined } from 'lodash';
import moment from 'moment';
import i18n from './i18n';
import { LocalStorage, STORAGE_KEY } from './localStorage';
import { v4 as uuidv4 } from 'uuid';

const Storage = new LocalStorage();

export const showData = (data: any) => {
  if (isNull(data) || isUndefined(data) || data.length === 0) return DEFAULT_EMPTY;
  else return data;
};

export const formatPrice = (price: number, isNonUnit?: boolean) => {
  return (
    price
      .toLocaleString('it-IT', { style: 'currency', currency: 'vnd' })
      .replace(/[^0-9\.-]+/g, '') + (isNonUnit ? '' : 'đ')
  );
};

export const isSuccessCode = (code?: number) => {
  return code ? String(code).length === 4 : false;
};

export const disableAllInput = () => {
  const listInput = document.getElementsByTagName('input');
  for (let i = 0; i < listInput.length; i++) {
    const input = listInput[i] as HTMLInputElement;
    input.disabled = true;
  }
};

export const enableAllInput = () => {
  const listInput = document.getElementsByTagName('input');
  for (let i = 0; i < listInput.length; i++) {
    const input = listInput[i] as HTMLInputElement;
    input.disabled = true;
  }
};

export const delayNavigate = (callback: () => any) => {
  setTimeout(() => {
    callback();
  }, DELAY_TRANSITION);
};

export const concatFullName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`;
};

export const formatDate = (date?: string) => {
  return date ? moment(date).format(DATE_FORMAT) : '';
};

export const formatDateTime = (date?: string) => {
  return date ? moment(date).format(DATETIME_FORMAT) : '';
};

export const formatDateTimeNow = (date?: string) => {
  const now = moment();
  const inputDate = moment(date);
  if (now.get('day') - inputDate.get('day') === 0) {
    if (i18n.language === 'vi') inputDate.locale('vi');
    else {
      inputDate.locale('en-us');
    }

    return date ? inputDate.fromNow() : '';
  } else return date ? moment(date).format(DATETIME_FORMAT) : '';
};

export const isNowDay = (date?: string) => {
  const now = moment();
  const inputDate = moment(date);

  return now.get('day') - inputDate.get('day') === 0;
};

export const convertToHTMLWithSup = (inputString: string) => {
  const outputString = inputString.replace(/m\^(\d)/g, 'm<sup>$1</sup>');

  return outputString;
};

export const getImageURL = (url: string) => {
  return `${IMAGE_URL}?path=${url}`;
};

export const fileToBase64 = (file: File) => {
  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onload = function () {
      const base64String = String(reader?.result);

      resolve(base64String || '');
    };

    reader.readAsDataURL(file);
  });
};

export const getMimeTypeFromBase64 = (base64: string) => {
  // RegExp to extract the MIME type part of the Base64 string
  const result = base64.match(/^data:(.*?);base64,/);

  if (result && result.length > 1) {
    return result[1];
  } else {
    return null; // or assume a default type, or throw an error, etc.
  }
};

export const getVersion = () => Storage.getStorageItem(STORAGE_KEY.APP_VERSION);

export const isPWA = () =>
  process.env.REACT_APP_DEV_MODE === 'true'
    ? true
    : window.matchMedia('(display-mode: standalone)').matches;

export const generateUUID = () => {
  return uuidv4();
};

export const getFileUrl = (url: string) => {
  return `${IMAGE_URL}?path=${url}`;
};
